import React, { useEffect } from "react";
import Blogcon from "./Blogcon";
import Infiry from "../About/Infiry";
import Callin from "../About/Callin";
import Aboutbanner from "../About/Aboutbanner";
import Divser from "../About/Divser";
import Youtube from "../Services/Youtube";
import { movetop } from "../../fun";
import { blogs } from "../../data/blogs";

function Blog() {
  useEffect(() => {
    movetop();
  }, []);

  type elem = {
    oneBody?: JSX.Element;
    twoBody?: JSX.Element;
    threeBody?: JSX.Element;
  };

  const elemnt: elem = {
    oneBody: <Blogcon blo={blogs} />,
    twoBody: <Infiry />,
    threeBody: <Callin />,
  };

  return (
    <>
      <Aboutbanner name="Blog" banner={"../photo/sam3.jpg"} />
      <div id="section-heading" className="-z-10 -top-56"></div>
      <div className="pt-10 pb-0"></div>
      <Divser elemnt={elemnt} />
      <Youtube />
    </>
  );
}

export default Blog;
